export const SEND_EMAIL_PENDING = 'sendEmailAgentPending';
export const SEND_EMAIL_FULFILLED = 'sendEmailAgentFulfilled';
export const SEND_EMAIL_REJECTED = 'sendEmailAgentRejected';
